import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, throwError } from "rxjs";
import { catchError, finalize, takeUntil } from "rxjs/operators";
import { SStatsCardEmployeeExaminationService } from "./s-stats-card-employee-examination.service";
import { EmployeeExaminationFilterInput, TotalizerEmployeeExaminationDto } from "../../core/interfaces/employee-examination-input";
import { TranslateService } from "@ngx-translate/core";
import { OccupationalHealthCertificateSituationType } from "../../core/enums/occupational-health-certificate-situation-type";

@Component({
    selector: "s-stats-card-employee-examination",
    templateUrl: "./s-stats-card-employee-examination.component.html",
    styleUrls: ["./s-stats-card-employee-examination.component.scss"]
})
export class SStatsCardEmployeeExaminationComponent implements AfterViewInit, OnDestroy {

    @Input() domain: string;
    @Input() service: string;
    @Input() employeeSearch: string;
    @Input() occupationalHealthCertificateSituation: OccupationalHealthCertificateSituationType;
    @Output() totalizerChangeEvent = new EventEmitter<TotalizerEmployeeExaminationDto>();

    totalizerCountLoading = true;
    totalizerCountError = false;

    private readonly _filter: EmployeeExaminationFilterInput = {};
    private readonly _ngUnsubscribe = new Subject();
    private _upToDateCount: string | number;
    private _expiredCount: string | number;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly _sStatsCardEmployeeExaminationService: SStatsCardEmployeeExaminationService
    ) {}

    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }

    @Input()
    public set ticket(ticket) {
        this._filter.ticket = ticket;
        if (ticket && this.domain && this.service) {
            this.updateCounters();
        }
    }
    ngAfterViewInit() {
        if (!this._filter?.ticket) {
            this.updateCounters();
        }
    }
    private genericGet(value: string | number): string {
        if (typeof value === 'string') {
            return value;
        }
        return value && value >= 1 ? value.toString() : '0';
    }

    private setFields() {
        this._filter.domain = this.domain;
        this._filter.service = this.getService();
        this._filter.employeeSearch = this.employeeSearch;
        this._filter.occupationalHealthCertificateSituation = this.occupationalHealthCertificateSituation;
    }

    public updateCounters() {
        this.totalizerCountLoading = true;
        const messageError = this._translateService.instant('hcm.analytics_sst.error_fetching_count');
        this.setFields();
        this._sStatsCardEmployeeExaminationService.totalizerEmployeeExaminationCardsCount(this._filter)
            .pipe(
                takeUntil(this._ngUnsubscribe),
                finalize(() => {
                    const totalizerChangeDto: TotalizerEmployeeExaminationDto = {
                        upToDateCount: this.upToDateCount,
                        expiredCount: this.expiredCount,
                    }
                    this.totalizerChangeEvent.next(totalizerChangeDto);
                })
            )
            .pipe(catchError((error) => {
                this.upToDateCount = messageError,
                this.expiredCount = messageError,
                this.totalizerCountLoading = false;
                this.totalizerCountError = true;
                return throwError(error);
            }))
            .subscribe((response: any) => {
                this.upToDateCount = response.result.upToDateCount;
                this.expiredCount = response.result.expiredCount;
                this.totalizerCountError = false;
                this.totalizerCountLoading = false;
            });

    }
    get upToDateCount() {
        return this.genericGet(this._upToDateCount);
    }

    set upToDateCount(value: string | number) {
        this._upToDateCount = value;
    }

    get expiredCount() {
        return this.genericGet(this._expiredCount);
    }

    set expiredCount(value: string | number) {
        this._expiredCount = value;
    }

    /**
     * Esse funÃ§Ã£o foi criada pra chavear o contexto do filtro avanÃ§ado.
     * Quando vier do analytics-frontend, deve passar o serviÃ§o analytics, quando abrir direto na tela
     * do analytics-sst, deve passar o serviÃ§o do analytics_sst
     * o parametro "ticket" sÃ³ vai vir na rota, atrÃ¡ves do analytics-frontend
     * @private
     */
    private getService() {
        let service = this.service;
        if (this.route?.snapshot?.queryParams["ticket"]) {
            service = "analytics";
        }
        return service;
    }

}
